import { getDisplayName, USIndicator } from '~/entities/reviewer'
import type { apiClient } from '~/shared/api/data-ingestion-api'
import { highlightText } from '~/shared/lib/highlight-text'
import { RadioButton, Text } from '~/shared/ui'
import { useFilters } from '../../../../model'

export function ReviewerItem({
  reviewer,
  searchValue,
}: {
  reviewer: apiClient.User
  searchValue: string
}) {
  const { filters, setFilters } = useFilters()
  return (
    <div
      className="flex w-full items-center gap-2 px-2 py-1"
      key={reviewer.sub}
    >
      <RadioButton
        className="w-full"
        label={
          <div className="flex w-full items-center justify-between gap-3 whitespace-normal">
            <Text appearance="BODY2">{highlightText(getDisplayName(reviewer), searchValue)}</Text>
            {!reviewer.is_offshore_user && (
              <USIndicator
                className="mr-2"
                tooltip="US Reviewer"
              />
            )}
          </div>
        }
        fullLabelWidth
        gutter
        size="small"
        checked={filters.reviewer === reviewer.sub}
        onChange={() => {
          setFilters({
            reviewer: reviewer.sub,
          })
        }}
      />
    </div>
  )
}
